"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    attrs: {
      width: 600,
      scroll: "keep"
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close");
      }
    },
    model: {
      value: _vm.isVisible,
      callback: function callback($$v) {
        _vm.isVisible = $$v;
      },
      expression: "isVisible"
    }
  }, [_vm.application ? _c("ModalApplicationDetails", {
    attrs: {
      application: _vm.application
    },
    on: {
      "start-application": function startApplication($event) {
        return _vm.$emit("start-application", $event);
      },
      "update-status": function updateStatus($event) {
        return _vm.$emit("update-status", $event);
      },
      "resume-application": function resumeApplication($event) {
        return _vm.$emit("resume-application", $event);
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;